import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export class Link extends AuxiliumComponent {
	constructor() {
		super();

		this.href = this.getAttribute("href") ?? "";
		this.target = this.getAttribute("target") ?? "";
		this.rel = this.getAttribute("rel") ?? "";
		this.download = this.hasAttribute("download");
	}

	parsedCallback() {
		const anchor = document.createElementWithContents("a", this.childNodes, {
			href: Browser.ResolveRelativeURL(this.href)
		});

		if (this.target) { anchor.target = this.target; }
		if (this.rel) { anchor.rel = this.rel; }
		if (this.download) { anchor.download = true; }

		this.appendChild(anchor);
	}
}